import { isInChina } from "./commonUtils.js";

const TIANDITU_TK = "5645e20a9c7facfd6d0b6735c9fd700c";
const MAPTILER_KEY = 'LcnJ1H0fGpWyrSyl4rbN';

/**
 * 你的门店数据
 * name: 门店标题，可多个门店用 、 拼接
 * address: 具体地址
 */
const newstoreList = [
    {
      name: "上海广台乔子汽车服务店、嘉实多汽车车膜旗舰店（天猫）、嘉实多汽车贴膜京东自营旗舰店",
      address: "中华人民共和国上海市上海市长宁区延安西路1448弄3号"
    },
    {
      name: "嘉实多尊享店（嘉川路店）",
      address: "中华人民共和国上海市上海市徐汇区上海市徐汇区嘉川路273号隔壁"
    },
    {
      name: "昆明车酷艺多帮（科业路店）",
      address: "中华人民共和国云南省昆明市五华区科业路165号"
    },
    {
      name: "昆明车酷艺多帮（莲花池店）",
      address: "中华人民共和国云南省昆明市五华区远建商务大厦负2层停车场"
    },
    {
      name: "上海斐骏汽车服务有限公司",
      address: "中华人民共和国上海市上海市闵行区上海市闵行区双柏路800号5幢103室"
    },
    {
      name: "吉悦铂雅名车养护中心",
      address: "中华人民共和国吉林省吉林市昌邑区吉林省吉林市昌邑区维昌街花溪雅苑1号楼"
    },
    {
      name: "义乌唐龙汽车用品公司",
      address: "中华人民共和国浙江省金华市义乌市稠城街道大都公寓1幢2单元502室"
    },
    {
      name: "昆明伍尔特汽车服务有限公司",
      address: "中华人民共和国云南省昆明市西山区富城车世界21栋155-162号"
    },
    {
      name: "建水车匠坊维修中心",
      address: "中华人民共和国云南省红河哈尼族彝族自治州建水县太和临安1号门对面车匠坊维修中心"
    },
    {
      name: "北京中升宝辉汽车销售服务有限公司",
      address: "中华人民共和国北京市北京市朝阳区北京市朝阳区德胜门外花虎沟18号"
    },
    {
      name: "西安中升之宝汽车销售服务有限公司",
      address: "中华人民共和国陕西省西安市灞桥区穆将王立交东辅道"
    },
    {
      name: "玉溪通力汽修",
      address: "中华人民共和国云南省玉溪市红塔区玉兴路69号"
    },
    {
      name: "玉溪荣海汽车服务有限公司",
      address: "中华人民共和国云南省玉溪市红塔区金苑小区9幢1号"
    },
    {
      name: "鹤庆县金港名车汇",
      address: "中华人民共和国云南省大理白族自治州鹤庆县云鹤镇钟鼓楼西50米金港商业城地下金港名车"
    },
    {
      name: "南京中升沃茂汽车销售服务有限公司",
      address: "中华人民共和国江苏省南京市江宁区上高路168号江苏世贸泰信东盛汽车贸易有限公司南京中升沃茂汽车销售服务有限公司"
    },
    {
      name: "北京中升之星汽车销售服务有限公司",
      address: "中华人民共和国北京市北京市朝阳区北京市朝阳区王四营马房寺路333号"
    },
    {
      name: "重庆中升之宝汽车销售服务有限公司",
      address: "中华人民共和国重庆市重庆市九龙坡区重庆市九龙坡区谢家湾民主四村（九滨路）"
    },
    {
      name: "大连中升丰田汽车销售服务有限公司",
      address: "中华人民共和国辽宁省大连市甘井子区华北路759号"
    },
    {
      name: "大连新盛荣奥迪汽车销售服务有限公司",
      address: "中华人民共和国辽宁省大连市沙河口区太原街357-2号"
    },
    {
      name: "大连新盛荣丰田汽车销售服务有限公司",
      address: "中华人民共和国辽宁省大连市金州区五一路999号"
    },
    {
      name: "大连虹港中升雷克萨斯汽车销售服务有限公司",
      address: "中华人民共和国辽宁省大连市甘井子区大连虹港路560号雷克萨斯"
    }
  ];


const storeList= [
  {
    name: "上海广台乔子汽车服务店",
    address: "上海市长宁区延安西路1448弄3号"
  },
  {
    name: "TS TYRE AUTOCARE SDN BHD (SUNWAY PJS)",
    address: "1, Jalan PJS 7/20b, Bandar Sunway, 47500 Subang Jaya, Selangor"
  },
  {
    name: "嘉实多汽车车膜旗舰店（天猫）",
    address: "上海市长宁区延安西路1448弄3号"
  },
  {
    name: "嘉实多汽车服务尊享店（上海嘉川路店）",
    address: "上海市徐汇区嘉川路273号"
  },
  {
    name: "昆明车酷艺多帮（科业路店）",
    address: "云南省昆明市五华区科业路165号"
  },
  {
    name: "Action Auto Agency (M) Sdn Bhd",
    address: "30, Jalan Segambut Pusat, Segambut, 51200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur, Malaysia"
  },
  {
    name: "昆明车酷艺多帮（莲花池店）",
    address: "云南省昆明市五华区远建商务大厦负2层停车场"
  },
  {
    name: "CAF Flagship Store",
    address: "12, Jalan PJU 3/43, Sunway Damansara Technology Park"
  },
  {
    name: "Deuts Auto Service Sdn Bhd",
    address: "22, Jalan Penyelenggara U1/77, Taman Perindustrian Batu Tiga, Hicom-glenmarie Industrial Park, 40150 Shah Alam, Selangor"
  },
  {
    name: "上海斐骏汽车服务有限公司",
    address: "上海市闵行区双柏路800号5幢103室"
  },
  {
    name: "吉悦铂雅名车养护中心",
    address: "吉林省吉林市昌邑区维昌街花溪雅苑1号楼"
  },
  {
    name: "义乌唐龙汽车用品公司",
    address: "浙江省金华市义乌市稠城街道大都公寓1幢2单元502室"
  },
  {
    name: "嘉实多汽车贴膜京东自营旗舰店",
    address: "上海市长宁区延安西路1448弄3号"
  },
  {
    name: "昆明伍尔特汽车服务有限公司",
    address: "云南省昆明市西山区富城车世界21栋155-162号"
  },
  {
    name: "建水车匠坊维修中心",
    address: "云南省红河哈尼族彝族自治州建水县太和临安1号门对面车匠坊维修中心"
  },
  {
    name: "北京中升宝辉汽车销售服务有限公司",
    address: "北京市朝阳区德胜门外花虎沟18号"
  },
  {
    name: "西安中升之宝汽车销售服务有限公司",
    address: "陕西省西安市灞桥区穆将王立交东辅道"
  },
  {
    name: "玉溪通力汽修",
    address: "云南省玉溪市红塔区玉兴路69号"
  },
  {
    name: "玉溪荣海汽车服务有限公司",
    address: "云南省玉溪市红塔区金苑小区9幢1号"
  },
  {
    name: "鹤庆县金港名车汇",
    address: "云南省大理白族自治州鹤庆县云鹤镇钟鼓楼西50米金港商业城地下金港名车"
  },
  {
    name: "南京中升沃茂汽车销售服务有限公司",
    address: "江苏省南京市江宁区上高路168号"
  },
  {
    name: "北京中升之星汽车销售服务有限公司",
    address: "北京市朝阳区王四营马房寺路333号"
  },
  {
    name: "重庆中升之宝汽车销售服务有限公司",
    address: "重庆市九龙坡区谢家湾民主四村九滨路"
  },
  {
    name: "大连中升丰田汽车销售服务有限公司",
    address: "辽宁省大连市甘井子区华北路759号"
  },
  {
    name: "大连新盛荣奥迪汽车销售服务有限公司",
    address: "辽宁省大连市沙河口区太原街357-2号"
  },
  {
    name: "大连新盛荣丰田汽车销售服务有限公司",
    address: "辽宁省大连市金州区五一路999号"
  },
  {
    name: "大连虹港中升雷克萨斯汽车销售服务有限公司",
    address: "辽宁省大连市甘井子区虹港路560号"
  },
  {
    name: "天津中升沃茂汽车销售有限公司",
    address: "天津市河西区解放南路489号"
  },
  {
    name: "大连中升汇迪汽车销售服务有限公司",
    address: "辽宁省大连市甘井子区华北路761号"
  },
  {
    name: "云南省澄江市名车汇汽车美容服务中心",
    address: "云南省玉溪市澄江市仙湖路东65号"
  },
  {
    name: "青岛中升汇迪汽车销售服务有限公司",
    address: "山东省青岛市崂山区海尔路170号"
  },
  {
    name: "大连中升凌志汽车销售服务有限公司",
    address: "辽宁省大连市甘井子区华北路500号"
  },
  {
    name: "郑州中升之宝汽车销售服务有限公司",
    address: "河南省郑州市中原区西三环与中原路交叉口东南角"
  },
  {
    name: "新疆中升汇迪汽车销售服务有限公司",
    address: "新疆维吾尔自治区乌鲁木齐市水磨沟区红光山路1888号"
  },
  {
    name: "新郑市中升汇宝汽车销售服务有限公司",
    address: "河南省郑州市新郑市龙湖镇郑新快速路与泰山路交叉口向南200米路西"
  },
  {
    name: "郑州中升裕迪汽车销售服务有限公司",
    address: "河南省郑州市中牟县白沙镇郑开大道与京港澳高速交汇处东3公里贾鲁河桥南800米路西"
  },
  {
    name: "洛阳中升汇宝汽车销售服务有限公司",
    address: "河南省洛阳市涧西区建设路152号"
  },
  {
    name: "郑州中升汇迪汽车销售服务有限公司",
    address: "河南省郑州市惠济区银通路东开元路南"
  },
  {
    name: "大连中升汽车销售服务有限公司",
    address: "辽宁省大连市甘井子区辛寨子街道虹港路560号"
  },
  {
    name: "大连中升庆通汽车销售服务有限公司",
    address: "辽宁省大连保税区填海区中港北二路18号"
  },
  {
    name: "大连中升裕德丰田汽车销售服务有限公司",
    address: "辽宁省大连市甘井子区山东路80-1号"
  },
  {
    name: "大连中升之星汽车销售服务有限公司",
    address: "辽宁省大连市沙河口区河曲街20号"
  },
  {
    name: "弥渡酷车族汽车装饰美容中心",
    address: "云南省大理白族自治州弥渡县弥城镇毗江路123号"
  },
  {
    name: "曲靖护航美车精护工坊",
    address: "云南省曲靖市麒麟区寥廓街道莫家新村66-20负一层B02、B04"
  },
  {
    name: "青岛中升沃盛",
    address: "山东省青岛市城阳区黑龙江中路300号"
  },
  {
    name: "福建中升之宝汽车销售服务有限公司",
    address: "福建省福州市仓山区建新镇金洲北路2号"
  },
  {
    name: "大理中升汽车销售服务有限公司",
    address: "云南省大理白族自治州大理市巍山路与风盛路交界处"
  },
  {
    name: "长沙中升之宝汽车销售服务有限公司",
    address: "湖南省长沙市岳麓区麓谷汽车世界"
  },
  {
    name: "郑州中升沃茂汽车销售服务有限公司",
    address: "河南省郑州市惠济区花园路与开元路交叉口向南50米路西"
  },
  {
    name: "沈阳中升汽车销售服务有限公司",
    address: "辽宁省沈阳市铁西区沈辽西路183号"
  },
  {
    name: "嘉实多汽车服务尊享店（上海星河湾店）",
    address: "上海市闵行区都庄路4174号"
  },
  {
    name: "沈阳市铁西区爱车联汽车洗车店",
    address: "辽宁省沈阳市铁西区兴工北街95-4号"
  },
  {
    name: "营口中升汽车销售服务有限公司",
    address: "辽宁省营口市老边区新营路南9号"
  },
  {
    name: "南京中升恒岳汽车销售服务有限公司",
    address: "江苏省南京市浦口区浦珠北路42号"
  }
]

/** 经纬度保留小数位数 */
const COORD_DECIMALS = 6;

function roundCoord(value, decimals = COORD_DECIMALS) {
  const num = Number(value);
  if (!Number.isFinite(num)) return num;
  return Number(num.toFixed(decimals));
}

function roundLngLat(geo) {
  return {
    ...geo,
    longitude: roundCoord(geo.longitude),
    latitude: roundCoord(geo.latitude),
  };
}

const PI = Math.PI;
const GCJ_A = 6378245.0;
const GCJ_EE = 0.00669342162296594323;

const outOfChina = (lng, lat) =>
  lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271;

const isMalaysiaCoordinate = (lng, lat) => {
  const numLng = Number(lng);
  const numLat = Number(lat);
  return (
    Number.isFinite(numLng) &&
    Number.isFinite(numLat) &&
    numLat >= 0.85 &&
    numLat <= 7.5 &&
    numLng >= 99 &&
    numLng <= 119.5
  );
};

const shouldApplyGcj02Offset = (lng, lat) => {
  const numLng = Number(lng);
  const numLat = Number(lat);
  if (!Number.isFinite(numLng) || !Number.isFinite(numLat)) return false;
  if (isMalaysiaCoordinate(numLng, numLat)) return false;
  return !outOfChina(numLng, numLat);
};

const transformLat = (lng, lat) => {
  let ret =
    -100.0 +
    2.0 * lng +
    3.0 * lat +
    0.2 * lat * lat +
    0.1 * lng * lat +
    0.2 * Math.sqrt(Math.abs(lng));
  ret +=
    ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
      2.0) /
    3.0;
  ret +=
    ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) /
    3.0;
  ret +=
    ((160.0 * Math.sin((lat / 12.0) * PI) +
      320 * Math.sin((lat * PI) / 30.0)) *
      2.0) /
    3.0;
  return ret;
};

const transformLng = (lng, lat) => {
  let ret =
    300.0 +
    lng +
    2.0 * lat +
    0.1 * lng * lng +
    0.1 * lng * lat +
    0.1 * Math.sqrt(Math.abs(lng));
  ret +=
    ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) *
      2.0) /
    3.0;
  ret +=
    ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) /
    3.0;
  ret +=
    ((150.0 * Math.sin((lng / 12.0) * PI) +
      300.0 * Math.sin((lng / 30.0) * PI)) *
      2.0) /
    3.0;
  return ret;
};

/** WGS84 → GCJ-02（仅中国大陆坐标） */
function wgs84ToGcj02(lng, lat) {
  const numLng = Number(lng);
  const numLat = Number(lat);
  if (!shouldApplyGcj02Offset(numLng, numLat)) {
    return { lng: numLng, lat: numLat };
  }
  let dLat = transformLat(numLng - 105.0, numLat - 35.0);
  let dLng = transformLng(numLng - 105.0, numLat - 35.0);
  const radLat = (numLat / 180.0) * PI;
  let magic = Math.sin(radLat);
  magic = 1 - GCJ_EE * magic * magic;
  const sqrtMagic = Math.sqrt(magic);
  dLat =
    (dLat * 180.0) / (((GCJ_A * (1 - GCJ_EE)) / (magic * sqrtMagic)) * PI);
  dLng = (dLng * 180.0) / ((GCJ_A / sqrtMagic) * Math.cos(radLat) * PI);
  return { lng: numLng + dLng, lat: numLat + dLat };
}

/** GCJ-02 → WGS84（仅中国大陆坐标） */
function gcj02ToWgs84(lng, lat) {
  const numLng = Number(lng);
  const numLat = Number(lat);
  if (!Number.isFinite(numLng) || !Number.isFinite(numLat)) {
    return { lng: numLng, lat: numLat };
  }
  if (!shouldApplyGcj02Offset(numLng, numLat)) {
    return { lng: numLng, lat: numLat };
  }
  let wgsLng = numLng;
  let wgsLat = numLat;
  for (let i = 0; i < 2; i += 1) {
    const gcj = wgs84ToGcj02(wgsLng, wgsLat);
    wgsLng = numLng - (gcj.lng - wgsLng);
    wgsLat = numLat - (gcj.lat - wgsLat);
  }
  return { lng: wgsLng, lat: wgsLat };
}

/**
 * 天地图 geocoder / T.Map 使用 GCJ-02（与底图一致）。
 * 转为 WGS84 后供 MapTiler 首页及后端使用。
 */
const TIANDITU_GEO_IS_GCJ02 = true;

/** 判断是否国内地址（走天地图）；马来西亚等走 MapTiler */
function isChinaAddress(address) {
  const addr = String(address || "").trim();
  if (!addr) return false;
  if (
    /malaysia|wilayah persekutuan|selangor|kuala lumpur|subang jaya|shah alam|damansara|sdn bhd|jalan /i.test(
      addr
    )
  ) {
    return false;
  }
  if (addr.startsWith("中华人民共和国")) return true;
  if (/^(北京市|上海市|天津市|重庆市)/.test(addr)) return true;
  if (/^[\u4e00-\u9fa5]{2,7}省/.test(addr)) return true;
  if (/[省市自治区]/.test(addr)) return true;
  return false;
}

/**
 * 调用天地图 geocoder（国内地址）
 * 返回 CGCS2000，常规场景可直接当作 WGS84 使用
 */
async function getGeoByTianditu(address, options = {}) {
  const convertToWgs84 = options.convertToWgs84 ?? TIANDITU_GEO_IS_GCJ02;
  const ds = JSON.stringify({
    keyWord: address,
  });

  const url = `https://api.tianditu.gov.cn/geocoder?ds=${encodeURIComponent(ds)}&tk=${TIANDITU_TK}`;

  const response = await fetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`天地图请求失败，HTTP 状态码：${response.status}`);
  }

  const result = await response.json();
  const location = result?.result?.location || result?.location;

  if (!location) {
    throw new Error(`未获取到经纬度：${JSON.stringify(result)}`);
  }

  let longitude = Number(location.lon);
  let latitude = Number(location.lat);
  if (convertToWgs84) {
    const wgs = gcj02ToWgs84(longitude, latitude);
    longitude = wgs.lng;
    latitude = wgs.lat;
  }

  return roundLngLat({
    longitude,
    latitude,
    coordSystem: convertToWgs84 ? "WGS84" : "GCJ-02",
    mapCoordSystem: "GCJ-02",
    source: "tianditu",
    level: location?.level || result?.result?.level || "",
    raw: result,
  });
}

/**
 * 天地图 POI 搜索（v2/search），楼栋/门牌比 geocoder 更精确
 */
async function getGeoCandidatesByTiandituSearch(keyword, options = {}) {
  const convertToWgs84 = options.convertToWgs84 ?? TIANDITU_GEO_IS_GCJ02;
  const keyWord = String(keyword || "").trim();
  if (!keyWord) return [];

  const queryType = Number(options.queryType || 2);
  const postStr = {
    keyWord,
    queryType,
    start: 0,
    count: Math.min(Number(options.limit) || 10, 20),
  };

  if (queryType === 3) {
    postStr.pointLonlat = options.pointLonlat;
    postStr.queryRadius = String(options.queryRadius || 1500);
  } else {
    postStr.level = String(options.level || 18);
    postStr.mapBound = options.mapBound || "73,18,135,54";
  }

  const url = `https://api.tianditu.gov.cn/v2/search?postStr=${encodeURIComponent(
    JSON.stringify(postStr)
  )}&type=query&tk=${TIANDITU_TK}`;

  const response = await fetch(url, { method: "GET" });
  if (!response.ok) {
    throw new Error(`天地图搜索请求失败，HTTP 状态码：${response.status}`);
  }

  const result = await response.json();
  const pois = Array.isArray(result?.pois) ? result.pois : [];
  if (!pois.length) return [];

  return pois
    .map((poi) => {
      const lonlat = String(poi?.lonlat || "");
      const [lngRaw, latRaw] = lonlat.split(",").map(Number);
      if (!Number.isFinite(lngRaw) || !Number.isFinite(latRaw)) return null;

      let longitude = lngRaw;
      let latitude = latRaw;
      if (convertToWgs84) {
        const wgs = gcj02ToWgs84(longitude, latitude);
        longitude = wgs.lng;
        latitude = wgs.lat;
      }

      const name = String(poi?.name || "").trim();
      const address = String(poi?.address || "").trim();

      return roundLngLat({
        longitude,
        latitude,
        coordSystem: convertToWgs84 ? "WGS84" : "GCJ-02",
        mapCoordSystem: "GCJ-02",
        source: "tianditu-search",
        placeName: [name, address].filter(Boolean).join(" "),
        placeType: "poi",
        level: poi?.typeName || "",
        poiName: name,
        poiAddress: address,
        relevance: 0.9,
        raw: poi,
      });
    })
    .filter(Boolean);
}

const getTiandituSearchMapBound = (anchor, radiusKm = 6, coordsAreGcj02 = false) => {
  if (!anchor?.longitude || !anchor?.latitude) return null;
  let lng = Number(anchor.longitude);
  let lat = Number(anchor.latitude);
  if (!coordsAreGcj02) {
    const gcj = wgs84ToGcj02(lng, lat);
    lng = gcj.lng;
    lat = gcj.lat;
  }
  const bbox = getBboxAroundPoint(lng, lat, radiusKm);
  if (!bbox) return null;
  return bbox.join(",");
};

const PLACE_TYPE_SCORE = {
  address: 100,
  street: 92,
  poi: 88,
  neighbourhood: 75,
  locality: 45,
  municipality: 42,
  region: 25,
  country: 10,
};

const COUNTRY_REGION_NAMES = new Set([
  "中国",
  "中华人民共和国",
  "china",
  "cn",
  "中國",
]);

const parseRegionAddressParts = (regionAddress) =>
  String(regionAddress || "")
    .split(/[,，]/)
    .map((item) => item.trim())
    .filter(Boolean);

/** 去掉国家层级，避免「中国江苏省…」干扰 geocoding */
const getRegionPartsWithoutCountry = (regionAddress) =>
  parseRegionAddressParts(regionAddress).filter(
    (part) => !COUNTRY_REGION_NAMES.has(String(part || "").trim().toLowerCase())
  );

/** 去掉连续重复的省/市/区，避免「上海市,上海市,长宁区」拼接成「上海市上海市…」 */
const dedupeRegionParts = (parts) => {
  const list = [];
  for (const part of parts || []) {
    const text = String(part || "").trim();
    if (!text) continue;
    if (list.length && list[list.length - 1] === text) continue;
    list.push(text);
  }
  // 去掉被更长项包含的短项，如「上海」+「上海市」只保留后者
  return list.filter(
    (part, index) =>
      !list.some(
        (other, otherIndex) =>
          index !== otherIndex &&
          other.length > part.length &&
          other.includes(part)
      )
  );
};

/** 详细地址若重复包含已选省市区前缀，去掉后再与 region 拼接 */
const stripRegionPrefixFromDetail = (detail, regionParts) => {
  let s = normalizeRegisterDetailAddress(detail);
  if (!s || !regionParts?.length) return s;

  const prefixes = [
    regionParts.join(""),
    regionParts.length >= 2 ? regionParts.slice(-2).join("") : "",
    ...regionParts,
  ]
    .filter((part) => part && part.length >= 2)
    .sort((a, b) => b.length - a.length);

  for (const prefix of prefixes) {
    if (s.startsWith(prefix)) {
      const rest = s.slice(prefix.length);
      if (rest.length >= 2) return rest;
    }
  }
  return s;
};

/** MapTiler 注册选点：英文/中文 region 拼接方式不同 */
const joinRegionPartsForGeocode = (regionParts) => {
  const parts = (regionParts || [])
    .map((item) => String(item || "").trim())
    .filter(Boolean);
  if (!parts.length) return "";
  const chinese = parts.some((part) => /[\u4e00-\u9fa5]/.test(part));
  return chinese ? parts.join("") : parts.join(", ");
};

const joinRegionWithDetailForGeocode = (regionParts, detail) => {
  const region = joinRegionPartsForGeocode(regionParts);
  const text = String(detail || "").trim();
  if (!region || !text) return region || text;
  const chinese =
    /[\u4e00-\u9fa5]/.test(region) || /[\u4e00-\u9fa5]/.test(text);
  return chinese ? `${region}${text}` : `${region}, ${text}`;
};

const MAPTILER_COUNTRY_NAME_TO_ISO2 = {
  malaysia: "my",
  singapore: "sg",
  thailand: "th",
  indonesia: "id",
  philippines: "ph",
  vietnam: "vn",
  "united states": "us",
  usa: "us",
  "united kingdom": "gb",
  uk: "gb",
  australia: "au",
  "new zealand": "nz",
  canada: "ca",
  germany: "de",
  france: "fr",
  japan: "jp",
  "south korea": "kr",
  korea: "kr",
  india: "in",
};

const resolveMapTilerCountryCode = (countryPart) => {
  const normalized = String(countryPart || "").trim().toLowerCase();
  if (!normalized) return "";
  if (MAPTILER_COUNTRY_NAME_TO_ISO2[normalized]) {
    return MAPTILER_COUNTRY_NAME_TO_ISO2[normalized];
  }
  if (/^[a-z]{2}$/.test(normalized)) return normalized;
  return "";
};

const looksLikeForeignStreetPart = (part) =>
  /^(?:\d+[a-z]?\s+)?(?:jalan|jln|lorong|lebih|persiaran|lengkok|street|st\.|road|rd|avenue|ave|boulevard|blvd|way|drive|dr|lane|ln|crescent|close|court|place|terrace|highway|hwy)\b/i.test(
    String(part || "").trim()
  ) || /^\d+\s*,?\s*(?:jalan|jln|street|road)\b/i.test(String(part || "").trim());

const isLikelyForeignCountryPart = (part) => {
  const normalized = String(part || "").trim().toLowerCase();
  if (!normalized) return false;
  if (MAPTILER_COUNTRY_NAME_TO_ISO2[normalized]) return true;
  if (/^[a-z]{2,3}$/.test(normalized)) return true;
  return /^(malaysia|singapore|indonesia|thailand|philippines|vietnam|united states|united kingdom|australia|new zealand|canada|germany|france|japan|korea|south korea|india|brunei|cambodia|myanmar|laos|hong kong|macau|taiwan)$/i.test(
    normalized
  );
};

const extractPostcodeAndCityFromPart = (part) => {
  const text = String(part || "").trim();
  const match = text.match(/^(\d{4,6}(?:\s*[-–—]\s*\d{4})?)\s+(.+)$/);
  if (!match) return { postcode: "", city: text };
  return { postcode: match[1].trim(), city: match[2].trim() };
};

const isLikelyForeignAdminPart = (part) => {
  const text = String(part || "").trim();
  if (!text || looksLikeForeignStreetPart(text)) return false;
  if (/^\d/.test(text)) return false;
  return true;
};

/**
 * 工具页 / 整串国外地址：按逗号从右向左拆 region + detail
 * 例：…, 47810 Petaling Jaya, Selangor, Malaysia
 */
const parseForeignFullAddressForTool = (rawAddress) => {
  const parts = String(rawAddress || "")
    .split(/[,，]/)
    .map((item) => item.trim())
    .filter(Boolean);

  if (!parts.length) {
    return {
      regionAddress: "",
      detailAddress: "",
      regionParts: [],
      countryCode: "",
      fullAddress: "",
    };
  }

  const regionParts = [];
  const remaining = [...parts];

  if (remaining.length > 1 && isLikelyForeignCountryPart(remaining[remaining.length - 1])) {
    regionParts.unshift(remaining.pop());
  }

  if (
    remaining.length > 1 &&
    isLikelyForeignAdminPart(remaining[remaining.length - 1])
  ) {
    regionParts.unshift(remaining.pop());
  }

  if (remaining.length > 1) {
    const tail = remaining[remaining.length - 1];
    const { postcode, city } = extractPostcodeAndCityFromPart(tail);
    if (postcode && city) {
      regionParts.unshift(city);
      remaining.pop();
    } else if (
      isLikelyForeignAdminPart(tail) &&
      !looksLikeForeignStreetPart(tail) &&
      remaining.length >= 3
    ) {
      regionParts.unshift(remaining.pop());
    }
  }

  const regionAddress = regionParts.join(",");
  const regionPartsDeduped = dedupeRegionParts(regionParts);
  const detailAddress = remaining.join(", ");
  const countryCode = resolveMapTilerCountryCode(
    regionPartsDeduped[regionPartsDeduped.length - 1] || ""
  );

  return {
    regionAddress,
    detailAddress,
    regionParts: regionPartsDeduped,
    countryCode,
    fullAddress: parts.join(", "),
  };
};

const extractForeignStreetKey = (text) => {
  const match = String(text || "").match(
    /(?:jalan|jln|lorong|street|road|avenue|ave|boulevard|blvd|way|drive|lane)\s+([^,]+)/i
  );
  if (!match) return "";
  return match[1].trim().toLowerCase().replace(/\s+/g, "");
};

const buildToolMapTilerGeocodeQueries = (rawAddress, parsed) => {
  const priority = [];
  const secondary = [];
  const fallback = [];
  const seen = new Set();
  const push = (value, bucket = secondary) => {
    const text = String(value || "").trim();
    if (!text || seen.has(text)) return;
    seen.add(text);
    bucket.push(text);
  };

  const keyword = String(rawAddress || "").trim();
  const detail = String(parsed.detailAddress || keyword).trim();
  const geocodeDetail = stripFloorAndUnitForGeocode(detail);
  const regionJoined = joinRegionPartsForGeocode(parsed.regionParts);
  const detailParts = detail
    .split(/[,，]/)
    .map((item) => item.trim())
    .filter(Boolean);
  const streetLine = detailParts.find((item) => looksLikeForeignStreetPart(item));
  const houseNum = detailParts.find((item) => /^\d+[a-z]?$/i.test(item));
  const suburb = detailParts.find(
    (item) =>
      item !== streetLine &&
      item !== houseNum &&
      !looksLikeForeignStreetPart(item) &&
      !/^\d+[a-z]?$/i.test(item)
  );

  // 优先街道 + 行政区（实测比整串地址准确得多）
  if (streetLine && regionJoined) {
    push(`${streetLine}, ${regionJoined}`, priority);
  }
  if (streetLine && houseNum && regionJoined) {
    push(`${houseNum} ${streetLine}, ${regionJoined}`, priority);
  }
  if (streetLine && suburb && regionJoined) {
    push(`${streetLine}, ${suburb}, ${regionJoined}`, priority);
  }
  if (streetLine) {
    push(streetLine, priority);
  }

  const compactDetail = detail
    .replace(/,\s*(\d+[a-z]?\s*,?\s*(?:jalan|jln|lorong|street|road)\b)/gi, " $1")
    .replace(/\s+/g, " ")
    .trim();
  if (compactDetail && regionJoined) {
    push(`${compactDetail}, ${regionJoined}`, secondary);
  }

  for (const query of buildRegisterMapTilerGeocodeQueries(
    parsed.regionParts,
    geocodeDetail || detail
  )) {
    push(query, secondary);
  }

  if (geocodeDetail && geocodeDetail !== detail) push(geocodeDetail, secondary);
  push(detail, fallback);
  push(parsed.fullAddress, fallback);
  push(keyword, fallback);

  return [...priority, ...secondary, ...fallback];
};

const scoreToolMapTilerCandidate = (item, { detail = "", queryUsed = "" } = {}) => {
  let score = scoreMapTilerRegisterCandidate(item);
  const placeName = String(item.placeName || "").toLowerCase();
  const sourceText = `${String(detail || "").toLowerCase()} ${String(queryUsed || "").toLowerCase()}`;
  const streetKey = extractForeignStreetKey(sourceText);
  const placeStreetKey = extractForeignStreetKey(placeName);
  const placeNorm = placeName.replace(/\s+/g, "");

  if (streetKey) {
    const keyNorm = streetKey.replace(/\s+/g, "");
    if (placeStreetKey === streetKey) {
      score += 150;
    } else if (placeNorm.includes(keyNorm)) {
      score += 100;
    } else if (placeStreetKey) {
      const roadPrefix = streetKey.replace(/[\d/].*$/, "");
      const placePrefix = placeStreetKey.replace(/[\d/].*$/, "");
      if (roadPrefix && placePrefix === roadPrefix) {
        score -= 120;
      }
    }
  }

  const placeType = String(item.placeType || "").toLowerCase();
  if (placeType === "postal_code") score -= 40;
  if (isCoarseMapTilerGeocode(item)) score -= 50;

  if (Number.isFinite(Number(item.relevance))) {
    score += Number(item.relevance) * 40;
  }

  return score;
};

const pickBestToolMapTilerCandidate = (candidates, context = {}) => {
  const list = (candidates || []).filter(
    (item) =>
      Number.isFinite(Number(item?.longitude)) &&
      Number.isFinite(Number(item?.latitude))
  );
  if (!list.length) return null;

  return list
    .map((item) => ({
      item,
      score: scoreToolMapTilerCandidate(item, {
        detail: context.detail,
        queryUsed: item.queryUsed,
      }),
    }))
    .sort((a, b) => b.score - a.score)[0]?.item || null;
};

/** 工具页（MapTiler）：解析整串地址 + 区域锚点 + 多档查询 + 择优 */
async function geocodeToolAddressByMapTiler(rawAddress) {
  const keyword = String(rawAddress || "").trim();
  if (!keyword) {
    throw new Error("请输入地址");
  }

  const parsed = parseForeignFullAddressForTool(keyword);
  const queries = buildToolMapTilerGeocodeQueries(keyword, parsed);
  const detail = String(parsed.detailAddress || keyword).trim();
  const countryCode = parsed.countryCode || undefined;

  let regionAnchor = null;
  const anchorQueries = [];
  if (parsed.regionParts.length >= 2) {
    anchorQueries.push(joinRegionPartsForGeocode(parsed.regionParts.slice(-2)));
  }
  if (parsed.regionParts.length) {
    anchorQueries.push(joinRegionPartsForGeocode(parsed.regionParts));
  }

  for (const anchorQuery of anchorQueries) {
    try {
      const list = await getGeoCandidatesByMapTiler(anchorQuery, {
        language: "en",
        country: countryCode,
        limit: 1,
      });
      if (list[0]) {
        regionAnchor = list[0];
        break;
      }
    } catch (error) {
      // try next anchor query
    }
  }

  let streetAnchor = null;
  const primaryStreetQuery = queries.find((query) =>
    extractForeignStreetKey(query)
  );
  if (primaryStreetQuery) {
    try {
      const list = await getGeoCandidatesByMapTiler(primaryStreetQuery, {
        language: "en",
        country: countryCode,
        limit: 3,
      });
      streetAnchor =
        list.find((item) => {
          const key = extractForeignStreetKey(detail);
          const placeKey = extractForeignStreetKey(item.placeName);
          return key && placeKey === key;
        }) || list[0] || null;
    } catch (error) {
      // ignore
    }
  }

  const anchor = streetAnchor || regionAnchor;
  const mapTilerOptions = {
    language: "en",
    country: countryCode,
    limit: 5,
    proximity: anchor
      ? { longitude: anchor.longitude, latitude: anchor.latitude }
      : undefined,
    bbox: anchor
      ? getBboxAroundPoint(
          anchor.longitude,
          anchor.latitude,
          streetAnchor ? 5 : 18
        )
      : undefined,
  };

  const candidates = [];
  for (const query of queries) {
    try {
      const list = await getGeoCandidatesByMapTiler(query, mapTilerOptions);
      candidates.push(...list.map((item) => ({ ...item, queryUsed: query })));
    } catch (error) {
      // try next query variant
    }
  }

  const best = pickBestToolMapTilerCandidate(candidates, { detail });
  if (!best) {
    throw new Error("地址定位失败，请检查地址或手动拖动地图标记");
  }

  return {
    ...best,
    matchedPlaceName: best.placeName || "",
    anchorUsed: Boolean(anchor),
    coarseGeocode: isCoarseMapTilerGeocode(best),
  };
}

/**
 * 注册选点（国外）：已选省市区 + 用户输入 detail 合并为整串，供工具页同款解析/查询复用。
 * 会去掉 detail 末尾与已选 region 重复的行政区，避免「Petaling, Petaling, Selangor」重复干扰。
 */
const buildForeignRegisterFullAddress = (regionAddress, detailAddress) => {
  const region = String(regionAddress || "").trim();
  const detail = String(detailAddress || "").trim();
  if (!detail) return region;
  if (!region) return detail;

  const regionPartsLower = parseRegionAddressParts(region).map((part) =>
    part.toLowerCase()
  );
  const detailParts = detail
    .split(/[,，]/)
    .map((item) => item.trim())
    .filter(Boolean);

  while (detailParts.length > 0) {
    const tail = detailParts[detailParts.length - 1];
    const tailLower = tail.toLowerCase();
    const { city } = extractPostcodeAndCityFromPart(tail);
    const tailNorm = String(city || tail).trim().toLowerCase();

    const overlapsRegion = regionPartsLower.some(
      (part) => part === tailLower || part === tailNorm
    );

    if (overlapsRegion) {
      detailParts.pop();
    } else {
      break;
    }
  }

  const cleanedDetail = detailParts.join(", ");
  if (!cleanedDetail) return region;

  const regionLower = region.toLowerCase();
  if (cleanedDetail.toLowerCase().includes(regionLower)) {
    return cleanedDetail;
  }

  return `${cleanedDetail}, ${region}`;
};

/** MapTiler 注册选点：按优先级构造查询词（已选区 + 清洗后的详细地址） */
const buildRegisterMapTilerGeocodeQueries = (regionParts, geocodeDetail) => {
  const detail = stripRegionPrefixFromDetail(geocodeDetail, regionParts);
  const regionText = joinRegionPartsForGeocode(regionParts);
  const cityDistrict =
    regionParts.length >= 2
      ? joinRegionPartsForGeocode(regionParts.slice(-2))
      : regionText;

  const queries = [];
  const push = (value) => {
    const text = String(value || "").trim();
    if (text && !queries.includes(text)) queries.push(text);
  };

  if (regionText && detail) push(joinRegionWithDetailForGeocode(regionParts, detail));
  if (cityDistrict && detail && cityDistrict !== regionText) {
    push(joinRegionWithDetailForGeocode(regionParts.slice(-2), detail));
  }
  if (detail) push(detail);

  return queries;
};

const MAPTILER_REGISTER_PLACE_TYPE_SCORE = {
  address: 100,
  street: 92,
  poi: 88,
  neighbourhood: 72,
  locality: 45,
  municipality: 30,
  region: 22,
  county: 18,
  country: 5,
};

const isCoarseMapTilerGeocode = (item) => {
  const type = String(item?.placeType || "").toLowerCase();
  const relevance = Number(item?.relevance);
  if (["county", "region", "municipality", "locality", "country"].includes(type)) {
    return !Number.isFinite(relevance) || relevance < 0.55;
  }
  return false;
};

const scoreMapTilerRegisterCandidate = (item) => {
  const type = String(item?.placeType || "").toLowerCase();
  const base = MAPTILER_REGISTER_PLACE_TYPE_SCORE[type] ?? 40;
  const relevance = Number.isFinite(Number(item?.relevance))
    ? Number(item.relevance) * 30
    : 0;
  return base + relevance;
};

const pickBestMapTilerRegisterCandidate = (candidates) => {
  const list = (candidates || []).filter(
    (item) =>
      Number.isFinite(Number(item?.longitude)) &&
      Number.isFinite(Number(item?.latitude))
  );
  if (!list.length) return null;

  return list
    .map((item) => ({ item, score: scoreMapTilerRegisterCandidate(item) }))
    .sort((a, b) => b.score - a.score)[0]?.item || null;
};

/** 注册选点（MapTiler）：复用工具页整串解析 + 街道优先多档查询 + 择优 */
async function geocodeRegisterAddressByMapTiler({
  regionAddress,
  detail,
}) {
  const fullAddress = buildForeignRegisterFullAddress(regionAddress, detail);
  const result = await geocodeToolAddressByMapTiler(fullAddress);

  return {
    ...result,
    approximateCommunityOnly: isApproximateCommunityGeocode(result, detail),
  };
};

/** 注册选点：候选点距区县锚点的最大允许距离（米） */
const REGISTER_GEOCODE_MAX_ANCHOR_DISTANCE_M = 45000;

const getBboxAroundPoint = (longitude, latitude, radiusKm = 28) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  const dLat = radiusKm / 110.54;
  const cosLat = Math.cos((lat * Math.PI) / 180) || 1;
  const dLng = radiusKm / (111.32 * cosLat);

  return [lng - dLng, lat - dLat, lng + dLng, lat + dLat];
};

/** 注册选点：去掉地址中多余空格，如「天馨花园 286 号楼」→「天馨花园286号楼」 */
const normalizeRegisterDetailAddress = (detail) =>
  String(detail || "").trim().replace(/\s+/g, "");

const CHINA_MUNICIPALITIES = ["北京市", "上海市", "天津市", "重庆市"];

/**
 * 工具页 / 整串国内地址：拆分为 region + detail，供 geocodeRegisterAddress 复用
 * 例：中华人民共和国南通市海门区睿园 19 号楼 → region=中华人民共和国,南通市,海门区 detail=睿园19号楼
 */
const parseChinaFullAddressForTool = (rawAddress) => {
  let s = normalizeRegisterDetailAddress(rawAddress);
  if (!s) {
    return { regionAddress: "", detailAddress: "", regionParts: [] };
  }

  const adminParts = [];

  for (const country of ["中华人民共和国", "中国"]) {
    if (s.startsWith(country)) {
      adminParts.push(country);
      s = s.slice(country.length);
      break;
    }
  }

  const takeSegment = (regex) => {
    const match = s.match(regex);
    if (!match?.[1]) return "";
    adminParts.push(match[1]);
    s = s.slice(match[1].length);
    return match[1];
  };

  takeSegment(/^(.+?(?:省|自治区|特别行政区))/);
  takeSegment(/^((?:北京|上海|天津|重庆)市)/);
  if (!CHINA_MUNICIPALITIES.some((name) => adminParts.includes(name))) {
    takeSegment(/^([\u4e00-\u9fa5]{2,12}?市)/);
  } else {
    const municipality = adminParts.find((part) =>
      CHINA_MUNICIPALITIES.includes(part)
    );
    if (municipality && s.startsWith(municipality)) {
      s = s.slice(municipality.length);
    }
  }
  takeSegment(/^([\u4e00-\u9fa5]{2,15}?(?:区|县|旗))/);

  const regionAddress = adminParts.join(",");
  const regionParts = dedupeRegionParts(getRegionPartsWithoutCountry(regionAddress));
  const detailAddress = s.trim() || String(rawAddress || "").trim();

  return { regionAddress, detailAddress, regionParts };
};

const buildToolTiandituFallbackQuery = (rawAddress) => {
  const parsed = parseChinaFullAddressForTool(rawAddress);
  const geocodeDetail = stripFloorAndUnitForGeocode(parsed.detailAddress);
  const regionJoined = parsed.regionParts.join("");
  if (regionJoined && geocodeDetail) {
    return `${regionJoined}${geocodeDetail}`;
  }
  return normalizeRegisterDetailAddress(rawAddress).replace(/^中华人民共和国/, "");
};

const extractRegisterBuildingNumber = (detail) => {
  const normalized = normalizeRegisterDetailAddress(detail);
  const match = normalized.match(/(\d+)号(?:楼|幢|栋)?/i);
  return match ? match[1] : null;
};

/** 注册选点：构造 geocoding 关键词，优先省市区完整前缀，避免仅「区+POI」误匹配 */
const buildRegisterGeocodeQueries = (regionAddress, detailAddress) => {
  const parts = dedupeRegionParts(getRegionPartsWithoutCountry(regionAddress));
  const detail = stripRegionPrefixFromDetail(
    normalizeRegisterDetailAddress(detailAddress),
    parts
  );
  const regionJoined = parts.join("");
  const queries = [];

  const pushQuery = (value) => {
    const text = normalizeRegisterDetailAddress(value);
    if (text && !queries.includes(text)) queries.push(text);
  };

  const buildingNum = extractRegisterBuildingNumber(detail);
  const buildingSuffixMatch = detail.match(/^(.+?)(\d+号(?:楼|幢|栋)?)$/i);

  if (regionJoined && detail) {
    if (buildingSuffixMatch && buildingNum) {
      const [, prefix, buildingPart] = buildingSuffixMatch;
      pushQuery(`${regionJoined}${prefix}${buildingNum}号楼`);
      if (!/楼|幢|栋/.test(buildingPart)) {
        pushQuery(`${regionJoined}${prefix}${buildingNum}号`);
      }
      pushQuery(`${regionJoined}${detail}`);
      if (parts.length >= 2) {
        pushQuery(`${parts.slice(-2).join("")}${prefix}${buildingNum}号楼`);
        pushQuery(`${parts.slice(-2).join("")}${detail}`);
      }
    } else {
      pushQuery(`${regionJoined}${detail}`);
      if (parts.length >= 2) {
        pushQuery(`${parts.slice(-2).join("")}${detail}`);
      }
    }
  } else if (detail) {
    pushQuery(detail);
  } else if (regionJoined) {
    pushQuery(regionJoined);
  }

  return queries;
};

/** 小区名 + 楼号：先定位小区，再周边搜楼栋 POI */
async function collectTiandituBuildingNearbyCandidates({
  regionAddress,
  detail,
  anchor,
  regionParts,
  convertToWgs84 = TIANDITU_GEO_IS_GCJ02,
}) {
  const normalized = normalizeRegisterDetailAddress(detail);
  const buildingMatch = normalized.match(/^(.+?)(\d+号(?:楼|幢|栋)?)$/i);
  const buildingNum = extractRegisterBuildingNumber(normalized);
  if (!buildingMatch || !buildingNum) return [];

  const communityName = buildingMatch[1];
  const regionJoined = regionParts.join("");
  let center = anchor;

  if (!center) {
    const centerQueries = [
      regionJoined ? `${regionJoined}${communityName}` : "",
      regionParts.length >= 2 ? `${regionParts.slice(-2).join("")}${communityName}` : "",
      communityName,
    ].filter(Boolean);

    for (const query of centerQueries) {
      try {
        center = await getGeoByTianditu(query, { convertToWgs84 });
        if (center) break;
      } catch (error) {
        // try next
      }
    }
  }

  if (!center?.longitude || !center?.latitude) return [];

  const pointLonlat = convertToWgs84
    ? (() => {
        const gcj = wgs84ToGcj02(center.longitude, center.latitude);
        return `${gcj.lng},${gcj.lat}`;
      })()
    : `${center.longitude},${center.latitude}`;
  const keywords = [
    `${communityName}${buildingNum}号楼`,
    `${communityName}${buildingNum}号`,
    `${buildingNum}号楼`,
  ];

  const candidates = [];
  for (const keyword of keywords) {
    try {
      const list = await getGeoCandidatesByTiandituSearch(keyword, {
        queryType: 3,
        pointLonlat,
        queryRadius: "2000",
        limit: 10,
        convertToWgs84,
      });
      candidates.push(...list);
    } catch (error) {
      // try next keyword
    }
  }

  return candidates;
};

const isApproximateCommunityGeocode = (candidate, detail) => {
  const buildingNum = extractRegisterBuildingNumber(detail);
  if (!buildingNum) return false;

  const placeName = normalizeRegisterDetailAddress(candidate?.placeName || "");
  const hasBuilding = [`${buildingNum}号楼`, `${buildingNum}号`, `${buildingNum}幢`].some(
    (token) => placeName.includes(token)
  );
  if (hasBuilding) return false;

  return /小区|花园|苑|新村|社区|公寓|里/.test(placeName);
};

/**
 * 去掉楼层/室号后再 geocoding，避免「5楼5B」等干扰匹配到错误位置。
 * 用户提交的完整地址不变，仅用于定位计算。
 */
function stripFloorAndUnitForGeocode(detail) {
  let s = normalizeRegisterDetailAddress(detail);
  if (!s) return s;

  const original = s;
  let prev;
  do {
    prev = s;
    s = s.replace(/\d+[Bb](?:室|号|房|户)?$/i, "");
    s = s.replace(/(?:地下)?\d+[楼层Ff]$/i, "");
    s = s.replace(/第\d+层$/i, "");
    s = s.replace(/(?:室|房|户)$/i, "");
    s = s.replace(/[—\-－]\d+[A-Za-z]?$/i, "");
    s = s.replace(/(?:之|附)\d+$/i, "");
  } while (s !== prev && s.length >= 4);

  return s.length >= 4 ? s : original;
};

const distanceMetersApprox = (lng1, lat1, lng2, lat2) => {
  const dx = (Number(lng2) - Number(lng1)) * 111320 * Math.cos((Number(lat1) * Math.PI) / 180);
  const dy = (Number(lat2) - Number(lat1)) * 110540;
  return Math.sqrt(dx * dx + dy * dy);
};

const scoreRegisterGeocodeCandidate = (
  candidate,
  { detail, geocodeDetail, anchor, regionParts = [] }
) => {
  let score = PLACE_TYPE_SCORE[candidate.placeType] || 55;

  if (candidate.fromBuildingLevelQuery) {
    score += 30;
  }

  if (candidate.source === "tianditu") {
    const level = String(candidate.level || "");
    if (/道路|门牌|兴趣点|住宅|村庄|街道|镇|乡|号|小区|大厦|广场/.test(level)) {
      score += 28;
    } else if (/区县|市级|省级|城市/.test(level)) {
      score -= 25;
    } else {
      score += 8;
    }
  }

  if (anchor && Number.isFinite(candidate.longitude) && Number.isFinite(candidate.latitude)) {
    const dist = distanceMetersApprox(
      anchor.longitude,
      anchor.latitude,
      candidate.longitude,
      candidate.latitude
    );
    if (dist <= 3000) score += 40;
    else if (dist <= 10000) score += 25;
    else if (dist <= 25000) score += 12;
    else if (dist <= REGISTER_GEOCODE_MAX_ANCHOR_DISTANCE_M) score += 4;
    else score -= 200;
  }

  const placeName = String(candidate.placeName || "");
  const normalizedPlace = placeName.replace(/\s+/g, "");
  regionParts.forEach((part) => {
    const name = String(part || "").trim();
    if (name.length >= 2 && placeName.includes(name)) {
      score += name.length >= 4 ? 18 : 10;
    }
  });

  const matchText = normalizeRegisterDetailAddress(geocodeDetail || detail || "");
  const buildingNum = extractRegisterBuildingNumber(matchText);
  if (buildingNum) {
    const buildingTokens = [
      `${buildingNum}号楼`,
      `${buildingNum}号`,
      `${buildingNum}幢`,
      `${buildingNum}栋`,
    ];
    const hasBuildingToken = buildingTokens.some((token) =>
      normalizedPlace.includes(token)
    );
    if (hasBuildingToken) {
      score += 55;
    } else if (/小区|花园|苑|新村|社区|公寓|里|园$/.test(normalizedPlace)) {
      score -= 40;
    }
  }

  if (matchText) {
    const probe = matchText.slice(0, Math.min(10, matchText.length));
    if (probe && normalizedPlace.includes(probe)) score += 18;
    if (probe.length >= 4 && normalizedPlace.includes(probe.slice(0, 4))) score += 8;
    const buildingMatch = matchText.match(/(\d+弄\d*号?楼?|\d+号(?:楼|幢|栋)?)/);
    if (buildingMatch && normalizedPlace.includes(buildingMatch[1])) score += 15;
  }

  if (candidate.source === "tianditu-search") {
    score += buildingNum ? 25 : 10;
  }

  if (Number.isFinite(candidate.relevance)) {
    score += Number(candidate.relevance) * 10;
  }

  return score;
};

const pickBestRegisterGeocodeCandidate = (candidates, context) => {
  let list = (candidates || []).filter(
    (item) =>
      Number.isFinite(Number(item?.longitude)) && Number.isFinite(Number(item?.latitude))
  );
  if (!list.length) return null;

  if (context.anchor) {
    const withDistance = list.map((item) => ({
      item,
      dist: distanceMetersApprox(
        context.anchor.longitude,
        context.anchor.latitude,
        item.longitude,
        item.latitude
      ),
    }));

    const inRange = withDistance.filter(
      (entry) => entry.dist <= REGISTER_GEOCODE_MAX_ANCHOR_DISTANCE_M
    );
    if (inRange.length) {
      list = inRange.map((entry) => entry.item);
    } else {
      withDistance.sort((a, b) => a.dist - b.dist);
      list = withDistance.slice(0, 3).map((entry) => entry.item);
    }
  }

  const ranked = list
    .map((item) => ({
      item,
      score: scoreRegisterGeocodeCandidate(item, context),
    }))
    .sort((a, b) => b.score - a.score);

  return ranked[0]?.item || null;
};

/** MapTiler geocoding 仅支持 ISO 639-1（如 en、zh），与 style 的 zh-Hans 不同 */
const normalizeMapTilerGeocodeLanguage = (language) => {
  const lang = String(language || "en")
    .trim()
    .toLowerCase();
  if (lang === "zh" || lang === "zh-hans" || lang === "zh-cn" || lang === "zh-hant") {
    return "zh";
  }
  return "en";
};

/**
 * MapTiler 正向 geocoding（支持 proximity / country / 多结果）
 */
async function getGeoCandidatesByMapTiler(address, options = {}) {
  const keyword = String(address || "").trim();
  if (!keyword) return [];

  const params = new URLSearchParams();
  params.set("key", MAPTILER_KEY);
  params.set("limit", String(options.limit || 5));
  params.set("language", normalizeMapTilerGeocodeLanguage(options.language));
  if (options.country) params.set("country", options.country);
  if (options.proximity?.longitude != null && options.proximity?.latitude != null) {
    params.set(
      "proximity",
      `${options.proximity.longitude},${options.proximity.latitude}`
    );
  }
  if (Array.isArray(options.bbox) && options.bbox.length === 4) {
    params.set("bbox", options.bbox.map(Number).join(","));
  }

  const url = `https://api.maptiler.com/geocoding/${encodeURIComponent(
    keyword
  )}.json?${params.toString()}`;

  const response = await fetch(url, { method: "GET" });
  if (!response.ok) {
    let detail = "";
    try {
      const errBody = await response.json();
      detail = errBody?.message || errBody?.error || JSON.stringify(errBody);
    } catch (e) {
      // ignore
    }
    throw new Error(
      detail
        ? `MapTiler 请求失败：${detail}`
        : `MapTiler 请求失败，HTTP 状态码：${response.status}`
    );
  }

  const result = await response.json();
  const features = Array.isArray(result?.features) ? result.features : [];

  return features
    .map((feature) => {
      const coords = feature?.geometry?.coordinates;
      if (!Array.isArray(coords) || coords.length < 2) return null;
      const [longitude, latitude] = coords.map(Number);
      if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) return null;

      return roundLngLat({
        longitude,
        latitude,
        coordSystem: "WGS84",
        source: "maptiler",
        placeName: feature?.place_name || "",
        placeType:
          feature?.place_type?.[0] ||
          feature?.properties?.type ||
          feature?.properties?.category ||
          "",
        relevance: Number(feature?.relevance),
        raw: feature,
      });
    })
    .filter(Boolean);
}

/**
 * 注册地址选点专用 geocoding：区域锚点 + MapTiler proximity 偏置 + 多关键词择优
 */
async function geocodeRegisterAddress({
  regionAddress,
  detailAddress,
  tiandituOnly = false,
}) {
  const detail = String(detailAddress || "").trim();
  if (!detail) {
    throw new Error("请输入具体地址");
  }

  const geocodeDetail = stripFloorAndUnitForGeocode(detail);
  const regionParts = dedupeRegionParts(getRegionPartsWithoutCountry(regionAddress));
  const regionText = regionParts.join("");

  const useTiandituApi = tiandituOnly;
  // tiandituOnly 时仅走天地图，不因 isInChina() 域名误开 MapTiler
  const useMaptilerApi = !tiandituOnly;

  // 境外 MapTiler 选点：合并已选区 + detail，走工具页同款国外 geocoding
  if (useMaptilerApi && !useTiandituApi) {
    return geocodeRegisterAddressByMapTiler({
      regionAddress,
      detail,
    });
  }

  const buildingQueries = buildRegisterGeocodeQueries(regionAddress, geocodeDetail);
  const fullQueries =
    geocodeDetail !== detail
      ? buildRegisterGeocodeQueries(regionAddress, detail)
      : [];
  const buildingQuerySet = new Set(buildingQueries);
  const queries = [...new Set([...buildingQueries, ...fullQueries])];

  const isChina = isChinaAddress(`${regionText}${detail}`);
  const convertToWgs84 = tiandituOnly ? false : TIANDITU_GEO_IS_GCJ02;
  const tiandituCoordOptions = { convertToWgs84 };

  let anchor = null;
  const anchorQueries = [];
  if (regionParts.length >= 2) {
    anchorQueries.push(regionParts.slice(-2).join(""));
  }
  if (regionText) {
    anchorQueries.push(regionText);
  }

  if (useTiandituApi) {
    for (const anchorQuery of anchorQueries) {
      try {
        anchor = await getGeoByTianditu(anchorQuery, tiandituCoordOptions);
        if (anchor) break;
      } catch (error) {
        // try next anchor query / provider
      }
    }
  }

  if (!anchor && regionText && useMaptilerApi) {
    try {
      const regionCandidates = await getGeoCandidatesByMapTiler(regionText, {
        language: normalizeMapTilerGeocodeLanguage(isChina ? "zh" : "en"),
        country: isChina ? "cn" : undefined,
        limit: 1,
      });
      anchor = regionCandidates[0] || null;
    } catch (innerError) {
      anchor = null;
    }
  }

  const candidates = [];
  const searchMapBound =
    useTiandituApi && isChina && anchor
      ? getTiandituSearchMapBound(anchor, 6, !convertToWgs84)
      : null;
  const mapTilerOptions = {
    language: normalizeMapTilerGeocodeLanguage(isChina ? "zh" : "en"),
    country: isChina && isInChina() ? "cn" : undefined,
    limit: 5,
    proximity: anchor
      ? { longitude: anchor.longitude, latitude: anchor.latitude }
      : undefined,
    bbox: anchor
      ? getBboxAroundPoint(anchor.longitude, anchor.latitude, 28)
      : undefined,
  };

  if (useTiandituApi && isChina && extractRegisterBuildingNumber(detail)) {
    try {
      const nearbyCandidates = await collectTiandituBuildingNearbyCandidates({
        regionAddress,
        detail,
        anchor,
        regionParts,
        convertToWgs84,
      });
      candidates.push(...nearbyCandidates);
    } catch (error) {
      // ignore
    }
  }

  for (const query of queries) {
    const fromBuildingLevelQuery = buildingQuerySet.has(query);

    try {
      if (useTiandituApi && isChina) {
        const td = await getGeoByTianditu(query, tiandituCoordOptions);
        candidates.push({
          ...td,
          placeName: td.raw?.result?.formatted_address || query,
          fromBuildingLevelQuery,
        });
      }
    } catch (error) {
      // try next query / provider
    }

    if (useTiandituApi && isChina && searchMapBound) {
      try {
        const searchList = await getGeoCandidatesByTiandituSearch(query, {
          mapBound: searchMapBound,
          queryType: 2,
          limit: 10,
          level: 18,
          convertToWgs84,
        });
        candidates.push(
          ...searchList.map((item) => ({
            ...item,
            fromBuildingLevelQuery,
          }))
        );
      } catch (error) {
        // try next query
      }
    }

    try {
      if (useMaptilerApi) {
        const mtList = await getGeoCandidatesByMapTiler(query, mapTilerOptions);
        candidates.push(
          ...mtList.map((item) => ({
            ...item,
            fromBuildingLevelQuery,
          }))
        );
      }
    } catch (error) {
      // try next query
    }
  }

  const best = pickBestRegisterGeocodeCandidate(candidates, {
    detail,
    geocodeDetail,
    anchor,
    regionParts,
  });

  if (!best) {
    throw new Error("地址定位失败，请检查地址或手动拖动地图标记");
  }

  return {
    ...best,
    matchedPlaceName: best.placeName || "",
    anchorUsed: Boolean(anchor),
    approximateCommunityOnly: isApproximateCommunityGeocode(best, detail),
  };
}

/**
 * 调用 MapTiler geocoding（境外地址，原生 WGS84）
 */
async function getGeoByMapTiler(address) {
  const url = `https://api.maptiler.com/geocoding/${encodeURIComponent(
    address
  )}.json?key=${MAPTILER_KEY}&limit=1`;

  const response = await fetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`MapTiler 请求失败，HTTP 状态码：${response.status}`);
  }

  const result = await response.json();
  const coords = result?.features?.[0]?.geometry?.coordinates;

  if (!Array.isArray(coords) || coords.length < 2) {
    throw new Error(`未获取到经纬度：${JSON.stringify(result)}`);
  }

  const [longitude, latitude] = coords.map(Number);
  if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) {
    throw new Error(`经纬度无效：${JSON.stringify(coords)}`);
  }

  return roundLngLat({
    longitude,
    latitude,
    coordSystem: "WGS84",
    source: "maptiler",
    placeName: result?.features?.[0]?.place_name || "",
    placeType:
      result?.features?.[0]?.place_type?.[0] ||
      result?.features?.[0]?.properties?.type ||
      "",
    relevance: Number(result?.features?.[0]?.relevance),
    raw: result,
  });
}

/** 地址 → WGS84（MapTiler geocoding，供内部工具页） */
async function geocodeAddressToWgs84(address) {
  const keyword = String(address || "").trim();
  if (!keyword) {
    throw new Error("请输入地址");
  }
  return getGeoByMapTiler(keyword);
}

const GEOCODE_TOOL_PROVIDER = {
  MAPTILER: "maptiler",
  TIANDITU: "tianditu",
};

/** 内部工具页：按 provider 解析单条地址；天地图坐标不转换，直接当作 WGS84 使用 */
async function geocodeAddressForTool(address, { provider = GEOCODE_TOOL_PROVIDER.MAPTILER } = {}) {
  const keyword = String(address || "").trim();
  if (!keyword) {
    throw new Error("请输入地址");
  }

  if (provider === GEOCODE_TOOL_PROVIDER.TIANDITU) {
    if (isChinaAddress(keyword)) {
      const parsed = parseChinaFullAddressForTool(keyword);
      const detailAddress = String(parsed.detailAddress || "").trim();

      if (detailAddress) {
        try {
          const geo = await geocodeRegisterAddress({
            regionAddress: parsed.regionAddress,
            detailAddress,
            tiandituOnly: true,
          });
          return {
            ...geo,
            coordSystem: "WGS84",
            placeName: geo.matchedPlaceName || geo.placeName || keyword,
            geoSource: GEOCODE_TOOL_PROVIDER.TIANDITU,
          };
        } catch (error) {
          // 结构化解析失败时回退到清洗后的整串 geocoder
        }
      }
    }

    const fallbackQuery = buildToolTiandituFallbackQuery(keyword);
    const geo = await getGeoByTianditu(fallbackQuery, { convertToWgs84: false });
    return {
      ...geo,
      coordSystem: "WGS84",
      placeName: geo.raw?.result?.formatted_address || fallbackQuery || keyword,
      geoSource: GEOCODE_TOOL_PROVIDER.TIANDITU,
    };
  }

  const geo = await geocodeToolAddressByMapTiler(keyword).catch(async () =>
    getGeoByMapTiler(keyword)
  );
  return {
    ...geo,
    coordSystem: "WGS84",
    geoSource: GEOCODE_TOOL_PROVIDER.MAPTILER,
  };
}

/** 批量地址 geocoding，provider: maptiler | tianditu */
async function batchGeocodeAddresses(
  addresses,
  { provider = GEOCODE_TOOL_PROVIDER.MAPTILER, delayMs = 300, onProgress } = {}
) {
  const list = (addresses || [])
    .map((item) => String(item || "").trim())
    .filter(Boolean);
  const resultList = [];

  for (let i = 0; i < list.length; i += 1) {
    const address = list[i];
    onProgress?.({ current: i + 1, total: list.length, address });

    try {
      const geo = await geocodeAddressForTool(address, { provider });
      resultList.push({
        address,
        success: true,
        placeName: geo.placeName || "",
        longitude: geo.longitude,
        latitude: geo.latitude,
        coordSystem: geo.coordSystem || "WGS84",
        geoSource: geo.geoSource || provider,
        latLngPair: `${geo.longitude},${geo.latitude}`,
      });
    } catch (error) {
      resultList.push({
        address,
        success: false,
        error: error?.message || "查询失败",
      });
    }

    if (i < list.length - 1 && delayMs > 0) {
      await sleep(delayMs);
    }
  }

  return resultList;
}

/** 批量地址 → WGS84，addresses 为已去重的地址数组 */
async function batchGeocodeAddressesToWgs84(
  addresses,
  { delayMs = 300, onProgress } = {}
) {
  return batchGeocodeAddresses(addresses, {
    provider: GEOCODE_TOOL_PROVIDER.MAPTILER,
    delayMs,
    onProgress,
  });
}

/**
 * 按地址自动选择 geocoder，统一输出 WGS84
 */
async function getGeoByAddress(address) {
  if (isChinaAddress(address)) {
    return getGeoByTianditu(address);
  }
  return getGeoByMapTiler(address);
}

/**
 * 延迟函数，避免请求过快
 */
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * 批量查询
 */
async function batchQueryGeo(storeList) {
    const resultList = [];
  
    for (const store of storeList) {
      try {
        const geo = await getGeoByAddress(store.address);
  
        resultList.push({
          ...store,
          longitude: geo.longitude,
          latitude: geo.latitude,
          coordSystem: geo.coordSystem,
          geoSource: geo.source,
          success: true,
        });

        console.log(`${store.name} 查询成功 (WGS84)`, geo);
      } catch (error) {
        resultList.push({
          ...store,
          longitude: null,
          latitude: null,
          success: false,
          error: error.message
        });
  
        console.error(`${store.name} 查询失败`, error);
      }
  
      // 每条请求间隔 5 秒
      await sleep(5000);
    }
  
    return resultList;
  }

/**
 * 按你要的格式输出
 */
function formatOutput(resultList) {
  return resultList.map(item => {
    if (item.success) {
      return `${item.name}：
    具体地址:${item.address}
    坐标系:${item.coordSystem || "WGS84"}
    经度 (Longitude/WGS84):${item.longitude}
    纬度 (Latitude/WGS84):${item.latitude}
    数据来源:${item.geoSource || "-"}`;
    }

    return `${item.name}：
    具体地址:${item.address}
    经度 (Longitude):获取失败
    纬度 (Latitude):获取失败
    失败原因:${item.error}`;
  }).join("\n\n");
}


/**
 * 把查询结果格式化成 Markdown 内容
 */
function formatMarkdownOutput(resultList) {
    const now = new Date().toLocaleString();
  
    let markdown = `# 门店经纬度查询结果\n\n`;
    markdown += `生成时间：${now}\n\n`;
    markdown += `---\n\n`;
  
    for (const item of resultList) {
      markdown += `## ${item.name}\n\n`;
      markdown += `- 具体地址：${item.address}\n`;
  
      if (item.success) {
        markdown += `- 坐标系：${item.coordSystem || "WGS84"}\n`;
        markdown += `- 经度 Longitude (WGS84)：${item.longitude}\n`;
        markdown += `- 纬度 Latitude (WGS84)：${item.latitude}\n`;
        markdown += `- 数据来源：${item.geoSource || "-"}\n`;
      } else {
        markdown += `- 经度 Longitude：获取失败\n`;
        markdown += `- 纬度 Latitude：获取失败\n`;
        markdown += `- 失败原因：${item.error}\n`;
      }
  
      markdown += `\n`;
    }
  
    return markdown;
  }
  
  /**
   * 下载 Markdown 文件
   */
  function downloadMarkdownFile(markdownContent, filename = "门店经纬度查询结果.md") {
    const blob = new Blob([markdownContent], {
      type: "text/markdown;charset=utf-8"
    });
  
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
  
    document.body.appendChild(a);
    a.click();
  
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  
  /**
   * 执行入口
   */
  async function run() {
    // 去掉国外地址，只保留国内地址
    // const chinaStoreList = storeList.filter(item =>
    //   item.address.startsWith("中华人民共和国")
    // );
  
    const resultList = await batchQueryGeo(storeList);
  
    const markdown = formatMarkdownOutput(resultList);
  
    console.log("Markdown 内容：");
    console.log(markdown);
  
    // 自动下载 Markdown 文件
    downloadMarkdownFile(markdown, "门店经纬度查询结果.md");
  
    return resultList;
  }
  
  // run();
// /**
//  * 执行
//  */
// async function run() {
//   const resultList = await batchQueryGeo(storeList);

//   const text = formatOutput(resultList);

//   console.log("最终结果：");
//   console.log(text);

//   return resultList;
// }

// run();


import messages from "@/locales/i18n-messages.js";
import { EN_US, getCurrentLanguage } from "@/effects/switchLanguageEffect";

const NAV_GEO_CACHE_KEY = "castrol_map_geo_cache_v1";
const NAV_GEO_CACHE_MS = 5 * 60 * 1000;

const isLikelyMacDesktop = () => {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return /macintosh|mac os x/i.test(ua) && !/android|iphone|ipad|mobile/i.test(ua);
};

const readGeoCache = () => {
  try {
    const raw = sessionStorage.getItem(NAV_GEO_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const lat = Number(parsed?.lat);
    const lng = Number(parsed?.lng);
    const at = Number(parsed?.at);
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || !Number.isFinite(at)) {
      return null;
    }
    if (Date.now() - at > NAV_GEO_CACHE_MS) return null;
    return { lat, lng, at };
  } catch {
    return null;
  }
};

const saveGeoCache = (lat, lng) => {
  try {
    sessionStorage.setItem(
      NAV_GEO_CACHE_KEY,
      JSON.stringify({ lat, lng, at: Date.now() })
    );
  } catch {
    // ignore
  }
};

const toCachedPosition = (cached) => ({
  coords: {
    latitude: cached.lat,
    longitude: cached.lng,
    accuracy: 0,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null,
  },
  timestamp: cached.at,
  fromCache: true,
});

const requestPosition = (geoOptions) =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, geoOptions);
  });

const resolveGeoLocale = (options = {}) => {
  const locale = options.locale;
  if (locale === EN_US || locale === "en" || locale === "en-US") return EN_US;
  if (locale === "zh-CN" || locale === "zh") return "zh-CN";
  const current = getCurrentLanguage();
  return current === EN_US ? EN_US : "zh-CN";
};

const geoMsg = (key, options = {}) => {
  const locale = resolveGeoLocale(options);
  const home = messages[locale]?.app?.home;
  const fallback = messages["zh-CN"]?.app?.home;
  return home?.[`map_geo_${key}`] || fallback?.[`map_geo_${key}`] || key;
};

const createGeoError = (key, options = {}, extra = {}) => {
  const error = new Error(geoMsg(key, options));
  error.geoKey = key;
  if (extra.code != null) error.code = extra.code;
  if (extra.timedOut) error.timedOut = extra.timedOut;
  return error;
};

const localizeGeoError = (error, options = {}) => {
  if (!error) return createGeoError("failed", options);
  if (error.code === 1) {
    error.message = geoMsg("permission_denied", options);
  } else if (error.code === 2) {
    error.message = geoMsg("unavailable", options);
  } else if (error.code === 3 || error.timedOut || error.message === "Timeout expired") {
    error.message = geoMsg("timeout", options);
  }
  return error;
};

const watchPositionOnce = (geoOptions, waitMs = 12000, localeOptions = {}) =>
  new Promise((resolve, reject) => {
    let watchId = null;
    let timerId = null;
    const finish = (fn, value) => {
      if (watchId != null) navigator.geolocation.clearWatch(watchId);
      if (timerId != null) clearTimeout(timerId);
      fn(value);
    };
    watchId = navigator.geolocation.watchPosition(
      (position) => finish(resolve, position),
      (error) => {
        if (error?.code === 1) finish(reject, localizeGeoError(error, localeOptions));
      },
      geoOptions
    );
    timerId = window.setTimeout(
      () => finish(reject, createGeoError("timeout", localeOptions, { code: 3, timedOut: true })),
      waitMs
    );
  });

/**
 * 获取当前位置；Mac 上 kCLErrorLocationUnknown(code 2) 时会降级重试，并用缓存兜底。
 */
async function getCurrentLocation(options = {}) {
  if (typeof navigator === "undefined" || !navigator.geolocation) {
    throw createGeoError("unsupported", options);
  }

  const cached = readGeoCache();
  if (options.preferCache !== false && cached) {
    return toCachedPosition(cached);
  }

  const quickTimeout = options.timeout ?? 5000;

  if (options.quick) {
    try {
      const position = await requestPosition({
        enableHighAccuracy: !isLikelyMacDesktop(),
        timeout: quickTimeout,
        maximumAge: isLikelyMacDesktop() ? 300000 : 30000,
      });
      const lat = Number(position?.coords?.latitude);
      const lng = Number(position?.coords?.longitude);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        saveGeoCache(lat, lng);
        return position;
      }
    } catch (error) {
      if (error?.code === 1) throw localizeGeoError(error, options);
      if (cached) return toCachedPosition(cached);
      throw localizeGeoError(error, options);
    }
    if (cached) return toCachedPosition(cached);
    throw createGeoError("failed", options);
  }

  const macDesktop = isLikelyMacDesktop();
  const attempts = macDesktop
    ? [
        // Mac 优先网络定位 + 系统缓存，减少 CoreLocation unknown
        { enableHighAccuracy: false, timeout: 20000, maximumAge: 300000 },
        { enableHighAccuracy: false, timeout: 30000, maximumAge: 0 },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 },
      ]
    : [
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 30000,
          ...options,
        },
        { enableHighAccuracy: false, timeout: 20000, maximumAge: 60000 },
      ];

  let lastError = null;

  for (let i = 0; i < attempts.length; i += 1) {
    try {
      const position = await requestPosition(attempts[i]);
      const lat = Number(position?.coords?.latitude);
      const lng = Number(position?.coords?.longitude);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        saveGeoCache(lat, lng);
        return position;
      }
    } catch (error) {
      lastError = localizeGeoError(error, options);
      if (error?.code === 1) throw lastError;
      if (i < attempts.length - 1) {
        await sleep(800);
      }
    }
  }

  if (macDesktop) {
    try {
      const watched = await watchPositionOnce(
        { enableHighAccuracy: false, maximumAge: 300000, timeout: 15000 },
        12000,
        options
      );
      const lat = Number(watched?.coords?.latitude);
      const lng = Number(watched?.coords?.longitude);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        saveGeoCache(lat, lng);
        return watched;
      }
    } catch (error) {
      lastError = localizeGeoError(error, options);
      if (error?.code === 1) throw lastError;
    }
  }

  if (cached) {
    return toCachedPosition(cached);
  }

  throw lastError || createGeoError("failed", options);
}

export {
  createGeoError,
  getCurrentLocation,
  gcj02ToWgs84,
  wgs84ToGcj02,
  getGeoByAddress,
  getGeoByTianditu,
  getGeoByMapTiler,
  geocodeRegisterAddress,
  geocodeAddressToWgs84,
  geocodeAddressForTool,
  batchGeocodeAddresses,
  batchGeocodeAddressesToWgs84,
  GEOCODE_TOOL_PROVIDER,
  isChinaAddress,
  parseChinaFullAddressForTool,
  parseForeignFullAddressForTool,
  roundCoord,
};